<template>
  <div class="calico-document-upload-inline-page">
    <div class="calico-file-item-container">
      <CalicoDocumentUploadInline />
    </div>
  </div>
</template>

<script>
import CalicoDocumentUploadInline from '@/components/calico/documentUploadInline/index.vue'
export default {
  name: 'CalicoDocumentUploadInlinePage',
  components: {
    CalicoDocumentUploadInline
  },
  data () {
    return {}
  }
}
</script>
<style lang="scss">
.calico-document-upload-inline-page {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 1rem;
  .calico-file-item-container {
    @include stack-space($space-large);
    @include inset-space($space-large);
    width: 459px;
  }
  .calico-file-item-container-2 {
    @include stack-space($space-large);
    @include inset-space($space-large);
    background: $color-neutral-darkest;
    width: 459px;
  }
}
</style>
